<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal" :id="id" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">

    <t-input label="Vendedor vinculado a usuário da plataforma?" v-model="yesOrNotLinkUser" :options="yesOrNotOptions"
             radio/>

    <div v-show="onYesLinkUser">

      <t-input v-model="form.userId" :options="usersOptions" :add-error="error.userId"
               label="Usuário da plataforma" :required="onYesLinkUser" select/>

    </div>


    <div v-show="!onYesLinkUser">

      <t-input v-model="form.name"  :add-error="error.name" label="Nome" :required="!onYesLinkUser"/>

    </div>

  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import userService from "@/services/modules/setting/User.service";

export default {
  name: "SellerDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-seller",
      title: "Cadastro rápido de Vendedor",
      okText: "Incluir Vendedor",
      form: {
        sellerId: 0,
        userId:0,
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      yesOrNotLinkUser: "N", //Valor padrão não possui vinculo com usuário
      usersOptions: [],
    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()

      this.pageFormIsLoaded = false

      //Setar alguma informações padrão por exemplo vindo de fora
      await userService.selectList("").then((list) =>{
        this.usersOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

      if (this.form.userId > 0) {
        this.yesOrNotLinkUser = "Y"
      }

    },

    async onSubmit() {

      //Validações específicas da tela

      await this.setInsertDialog("business/seller", (item) => {

        this.itemInserted.value = item.sellerId
        this.itemInserted.text = this.form.name

        this.successInsert()

      })

    }
  },
  computed: {
    onYesLinkUser() {
      return this.yesOrNotLinkUser === 'Y'
    }
  },
  watch:{
    noOptionAdd(){
      this.form.name = this.noOptionAdd
    }
  },

}
</script>
